export class MarketingWinsEnvironment {
  public static getName = () => 'benzinga-marketing-wins';
  public static getEnvironment = (env: Record<string, string>) => ({
    apiKey: env.apiKey ?? 'O4fEmFjaFEkfstJ4UczDumMDTTzaFC021-HcwUqRcxU',
    environment: env.environment ?? 'master',
    space: env.space ?? 'dyq17v8dp1mo',
    url: new URL(env.url ?? 'https://www.benzinga.com'),
  });
}
